// extracted by mini-css-extract-plugin
export default {"link":"lD-z","disabled":"mD-z"};